import {
    ADD_DETAILWINDOW, REMOVE_DETAILWINDOW, SET_DETAILWINDOW, STEP_DETAILWINDOW, SET_DETAILWINDOW_TAB
} from '../actions/details';
import * as uuid from 'uuid';

const MAX_HISTORY = 50;

const defaultState = {
    detailwindows: []
};

function updateWindow(state, windowId, updater) {
    const detailwindows = (state.detailwindows || []).map(dw => {
        return dw.id === windowId ? updater(dw) : dw;
    });
    return {...state, detailwindows: detailwindows};
}

export default function details(state = defaultState, action) {
    switch (action.type) {
        case REMOVE_DETAILWINDOW: {
            const windowId = action.window.id;
            const detailwindows = (state.detailwindows || []).filter(dw => dw.id !== windowId);
            return {...state, detailwindows: detailwindows};
        }
        case ADD_DETAILWINDOW: {
            const detailwindows = (state.detailwindows || []).concat();
            detailwindows.push({
                id: uuid.v4(),
                feature: action.feature,
                tab: undefined,
                past: [],
                future: []
            });
            return {...state, detailwindows: detailwindows};
        }
        case SET_DETAILWINDOW: {
            return updateWindow(state, action.windowId, dw => {
                if (action.replace) {
                    return {...dw, feature: action.feature};
                }
                return {
                    ...dw,
                    feature: action.feature,
                    tab: undefined,
                    past: [...dw.past, {feature: dw.feature, tab: dw.tab}].slice(-MAX_HISTORY),
                    future: []
                };
            });
        }
        case STEP_DETAILWINDOW: {
            return updateWindow(state, action.windowId, dw => {
                const current = {feature: dw.feature, tab: dw.tab};
                if (action.delta < 0 && dw.past.length > 0) {
                    const target = dw.past[dw.past.length - 1];
                    return {...dw, ...target, past: dw.past.slice(0, -1), future: [current, ...dw.future]};
                } else if (action.delta > 0 && dw.future.length > 0) {
                    const target = dw.future[0];
                    return {...dw, ...target, past: [...dw.past, current], future: dw.future.slice(1)};
                }
                return dw;
            });
        }
        case SET_DETAILWINDOW_TAB: {
            return updateWindow(state, action.windowId, dw => {
                return dw.tab === action.tab ? dw : {...dw, tab: action.tab};
            });
        }
        default:
            return state;
    }
}
